import styled from 'styled-components';
import { cssVars } from '../lib/styledTheme';

export const ProtectedRouteLoading = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background-color: ${cssVars.bgColor};
  gap: 16px;
`;

export const ProtectedRouteSpinner = styled.div`
  font-size: 48px;
  animation: spin 1s linear infinite;

  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
`;

export const ProtectedRouteText = styled.div`
  font-size: 16px;
  color: ${cssVars.textSecondary};
`;

